import { render } from "./SuppliersView.vue?vue&type=template&id=d129db80"
import script from "./SuppliersView.vue?vue&type=script&lang=js"
export * from "./SuppliersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__